// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Image, Button, Grid, Form, Loader, Container, Segment, Label } from 'semantic-ui-react'
import fire from '../config/Fire'
var validUrl = require('valid-url')

export default class ManageWordPress extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      error: null,
      url: ''
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.userData()
      } else {
        this.props.history.push('/')
      }
    })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        this.setState({
          wordpressURL: obj.wordpressURL,
          loading: false,
          fetching: false
        })
        this.blogInfo()
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  enableWordpress = () => {
    this.setState({ fetching: true, error: null })
    if (validUrl.isUri(this.state.url)) {
      fetch('https://murkstomstag.herokuapp.com/api/v1/add/wordpress', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userUnderscore: this.state.userUnderscore,
          wordpressURL: this.state.url
        })
      }).then((response) => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', fetching: false })
        }
      })
    } else {
      this.setState({ fetching: false, error: true })
    }
  }

  disableWordpress = () => {
    this.setState({ fetching: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/remove/wordpress', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    }).then((response) => {
      if (response.status === 200) {
        this.userData()
      } else {
        this.setState({ error: 'Internal Server Error |  code 500', fetching: false })
      }
    })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  blogInfo = () => {
    let { wordpressURL } = this.state
    console.log('wordpressURL :', wordpressURL)
    var url = wordpressURL + '/wp-json/'
    if (wordpressURL !== undefined) {
      fetch(url)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          this.setState({
            wordpressURL: this.state.wordpressURL,
            blogTitle: data.name,
            blogDesc: data.description,
            loading: false
          })
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error: error.message
          })
        })
    }
  }

  render () {
    let { blogTitle, blogDesc, loading, wordpressURL, wordpress, fetching, error } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <Image
            centered
            style={{ width: '30px' }}
            src='https://image.flaticon.com/icons/svg/174/174881.svg'
          />
          <h2>Manage WordPress Blog</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='top' fluid>
          <Grid.Column width='2' />
          <Grid.Column width='10'>
            <div className='screen-card'>
              <Segment basic padded>
                {wordpressURL && (
                  <div className='mbs'>
                    <Label style={{ backgroundColor: '#F4D271' }} size='small'>
                      {wordpressURL}
                    </Label>
                    <h3>{blogTitle || '...'}</h3>
                    <p>{blogDesc || '...'}</p>
                  </div>
                )}
                {loading && <Loader size='small' color='blue' active inline />}
                {!loading && !wordpressURL && (
                  <div className='mtb center'>
                    <p>Such empty!</p>
                  </div>
                )}
                {wordpressURL && !loading && !fetching && (
                  <Button.Group>
                    <Button color='black' href='/wordpress'>
                      Preview Blog
                    </Button>
                    <Button
                      content='Disable'
                      color='black'
                      compact
                      basic
                      onClick={() => this.disableWordpress()}
                    />
                  </Button.Group>
                )}
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='4'>
            <div className='screen-card'>
              <Segment fluid basic>
                <p>Enter your URL</p>
                <Form fluid error={error}>
                  <Form.Input
                    disabled={fetching}
                    type='text'
                    onChange={this.handleChange}
                    placeholder='https://mywordpressblog.com/'
                    name='url'
                  />
                  <Form.Button
                    loading={fetching}
                    disabled={loading}
                    error={error}
                    content={!error ? 'Submit' : error}
                    onClick={this.enableWordpress}
                    color={!error ? 'black' : 'red'}
                  />
                </Form>
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='2' />
        </Grid>
      </Container>
    )
  }
}
